module.exports = __webpack_public_path__ + "static/media/embedded.520dc639.png";